// @ts-ignore — xlsx-populate 브라우저 번들은 d.ts 없음 (buildVatExcel.ts 와 동일 패턴)
import XlsxPopulate from 'xlsx-populate/browser/xlsx-populate';
import { OutputRow } from './transform';

// 동명이인(이름 같지만 다른 사람) 이름 셀 강조색 — yellow-200
export const HOMONYM_FILL = 'FEF08A';

const HEADERS = ['날짜', '이름', '품목', '수량'];

export async function buildSundumbiWorkbook(rows: OutputRow[]): Promise<any> {
  const wb = await XlsxPopulate.fromBlankAsync();
  const ws = wb.sheet(0);
  ws.name('정산');

  HEADERS.forEach((h, c) => ws.cell(1, c + 1).value(h));

  rows.forEach((r, i) => {
    const rowNum = i + 2;
    ws.cell(rowNum, 1).value(r.date);
    ws.cell(rowNum, 2).value(r.name);
    ws.cell(rowNum, 3).value(r.item);
    ws.cell(rowNum, 4).value(r.qty);
    // 동명이인이 존재하는 이름 셀만 강조 (이름 표시 행에만 homonym=true)
    if (r.homonym) ws.cell(rowNum, 2).style('fill', HOMONYM_FILL);
  });

  return wb;
}

export async function buildSundumbiBlob(rows: OutputRow[]): Promise<Blob> {
  const wb = await buildSundumbiWorkbook(rows);
  return wb.outputAsync() as Promise<Blob>;
}
